
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./pages/shared/Layout";
import Testimonial from "./pages/Testimonial";
import Team from "./pages/Team";
import Appointment from "./pages/Appointment";
import Feature from "./pages/Feature";
import Service from "./pages/WebDevelopmentServices";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import AboutUs from './pages/AboutUs'
import Blogs from './pages/Blogs'
import CallUs from './pages/CallUs'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Terms from './pages/Terms'
import Sitemap from './pages/Sitemap'
import CategoryPage from './pages/CategoryPage'
import ECommerce from './pages/ECommerce'
import BusinessAutomation from './pages/BusinessAutomationCloud'
import CustomSoftwareDevelopment from "./pages/CustomSoftwareDevelopment";
import MobileAppDevelopment from "./pages/MobileAppDevelopment";
import DigitalMarketingServices from "./pages/DigitalMarketingSEO";
import ContentManagementSystem from "./pages/ContentManagementSystem";
import CustomerRelationshipManagement from "./pages/CustomerRelationshipManagement";
import OnPayroll from "./pages/OnPayroll";

import NotFound from "./pages/NotFound";

function ChangeApp() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />}></Route>
                    <Route path="index" element={<Home />}></Route>
                    {/* Static routes defined below */}

                    <Route path="about-us" element={<AboutUs />}></Route>
                    <Route path="contact-us" element={<Contact />}></Route>
                    <Route path="service" element={<Service />}></Route>
                    <Route path="features" element={<Feature />}></Route>
                    <Route path="appointment" element={<Appointment />}></Route>
                    <Route path="team" element={<Team />}></Route>
                    <Route path="testimonial" element={<Testimonial />}></Route>
                    <Route path="blogs" element={<Blogs />}></Route>
                    <Route path="ecommerce" element={<ECommerce />}></Route>
                    <Route path="call-us" element={<CallUs />}></Route>
                    <Route path="privacy-policy" element={<PrivacyPolicy />}></Route>
                    <Route path="terms-and-conditions" element={<Terms />}></Route>
                    <Route path="on-payroll" element={<OnPayroll />}></Route>
                    <Route path="mobile-app-development" element={<MobileAppDevelopment />}></Route>
                    <Route path="digital-marketing" element={<DigitalMarketingServices />}></Route>
                    <Route path="custome-software-development" element={<CustomSoftwareDevelopment />}></Route>
                    <Route path="customer-relationship-management" element={<CustomerRelationshipManagement />}></Route>
                    <Route path="content-management-system" element={<ContentManagementSystem />}></Route>
                    <Route path="business-automation-&-cloud" element={<BusinessAutomation />}></Route>
                   <Route path="sitemap" element={<Sitemap />}></Route>
                        <Route path="category/:slug" element={<CategoryPage />}></Route>
                    <Route path="*" element={<NotFound />}></Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );

}

export default ChangeApp;
